import {Product as ProductInterface} from 'components/customer/Product/entity/Product';
import {PartialRoom} from 'shared/types/PartialRoom';
import {UpperHeight, UpperDepth} from 'assets';
import {SelectionInterface} from 'components/customer/Product/helpers/entity/SelectionRules';
import {ProductType} from './entity/ProductType';

export const getUpperProductSelection = ({
    product,
    room,
    cabinetFormFieldDefaults,
    measurement,
}: {
    product: ProductInterface;
    room: PartialRoom;
    cabinetFormFieldDefaults: Record<string, string | number>;
    measurement: string;
}): SelectionInterface[] => {
    const rules = [];
    if (product.cabinet_style != ProductType.UPPER) {
        return null;
    }
    if (typeof product.cabinet_height != 'undefined') {
        if (
            (typeof cabinetFormFieldDefaults != 'undefined' &&
                typeof cabinetFormFieldDefaults.cabinet_height != 'undefined' &&
                product.cabinet_height != room.upperHeight &&
                cabinetFormFieldDefaults.cabinet_height !=
                    product.cabinet_height) ||
            (typeof cabinetFormFieldDefaults.cabinet_height == 'undefined' &&
                product.cabinet_height != room.upperHeight)
        ) {
            rules.push({
                key: 'upper_height',
                name: 'Upper Height',
                is_saved:
                    room.customerOptions &&
                    room.customerOptions.isUpperHeightSet,
                room_data: `${room.upperHeight} ${measurement}`,
                set_key: 'isUpperHeightSet',
                product_data: `${product.cabinet_height} ${measurement}`,
                value: product.cabinet_height,
                image: String(UpperHeight),
                apply_to_room: true,
            });
        }
    }

    if (typeof product.cabinet_depth != 'undefined') {
        if (
            (typeof cabinetFormFieldDefaults != 'undefined' &&
                typeof cabinetFormFieldDefaults.cabinet_depth != 'undefined' &&
                cabinetFormFieldDefaults.cabinet_depth !=
                    product.cabinet_depth &&
                product.cabinet_depth != parseInt(room.upperDepth)) ||
            (typeof cabinetFormFieldDefaults.cabinet_depth == 'undefined' &&
                product.cabinet_depth != parseInt(room.upperDepth))
        ) {
            rules.push({
                key: 'upper_depth',
                name: 'Upper Depth',
                is_saved:
                    room.customerOptions &&
                    room.customerOptions.isUpperDepthSet,
                set_key: 'isTallDepthSet',
                room_data: `${room.upperDepth} ${measurement}`,
                product_data: `${product.cabinet_depth} ${measurement}`,
                value: product.cabinet_depth,
                image: String(UpperDepth),
                apply_to_room: true,
            });
        }
    }

    return rules;
};
